import React from 'react';
import { Button, Dialog, DialogTitle, MenuItem } from '@mui/material';
import { SimpleForm, Toolbar, useRecordContext } from 'react-admin';
import DateTimeInput from 'components/DateTimeInput';
import useDialog from 'hooks/useDialog';
import { PhoneScreenScheduledStatus } from '../ApplicationStatusControl';
import { useFormContext } from 'react-hook-form';
import ScreenerAccountInput from 'components/Filter/ScreenerAccountInput';

type PhoneScreenScheduledItemProps = {
  updateApplicationStatus: (val: any) => void;
};

const PhoneScreenScheduledItem = ({ updateApplicationStatus }: PhoneScreenScheduledItemProps) => {
  const { open, closeDialog, openDialog } = useDialog();

  return (
    <>
      <MenuItem onClick={openDialog}>Move to Phone Screen Scheduled (Manual)</MenuItem>
      <SchedulePhoneScreenDialog
        open={open}
        closeDialog={closeDialog}
        updateApplicationStatus={updateApplicationStatus}
      />
    </>
  );
};

const SchedulePhoneScreenToolBar = ({ closeDialog }) => {
  const { getValues } = useFormContext();
  return (
    <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Button onClick={closeDialog}>Cancel</Button>
      <Button
        type="submit"
        variant="contained"
        color="primary"
        disabled={!getValues().screener_account_id || !getValues().scheduled_time}
      >
        Submit
      </Button>
    </Toolbar>
  );
};

const SchedulePhoneScreenDialog = ({ open, closeDialog, updateApplicationStatus }) => {
  const record = useRecordContext();
  const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const submitUpdateApplicationStatus = ({ screener_account_id, scheduled_time }: any) => {
    updateApplicationStatus({
      application_status: PhoneScreenScheduledStatus,
      screener_account_id,
      scheduled_time,
      professional_id: record?.id,
      reason: 'application',
      screening_type: 'phone',
    });
  };

  return (
    <Dialog open={open} onClose={closeDialog}>
      <DialogTitle>Schedule Phone Screening</DialogTitle>
      <SimpleForm
        onSubmit={submitUpdateApplicationStatus}
        toolbar={<SchedulePhoneScreenToolBar closeDialog={closeDialog} />}
      >
        <ScreenerAccountInput
          source="screener_account_id"
          label="Screening Recruiter"
          fullWidth
          alwaysOn
        />
        <DateTimeInput
          label="Phone Screen Date And Time"
          source="scheduled_time"
          time_zone={browserTimezone}
          ampm
        />
      </SimpleForm>
    </Dialog>
  );
};

export default PhoneScreenScheduledItem;
